<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,16C3.58172,16,0,12.4183,0,8C0,3.58172,3.58172,0,8,0C12.4183,0,16,3.58172,16,8C16,12.4183,12.4183,16,8,16C8,16,8,16,8,16ZM8,14C11.3137,14,14,11.3137,14,8C14,4.68629,11.3137,2,8,2C4.68629,2,2,4.68629,2,8C2,11.3137,4.68629,14,8,14C8,14,8,14,8,14ZM9,12C9,12,7,12,7,12C7,12,7,10,7,10C7,10,9,10,9,10C9,10,9,12,9,12C9,12,9,12,9,12ZM9,9C9,9,7,9,7,9C7,9,7,4,7,4C7,4,9,4,9,4C9,4,9,9,9,9C9,9,9,9,9,9Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Issue',
} as DefineComponent
</script>
